import {
    GET_INSPECTION_STATUS_MASTER, GET_ALL_MASTER_DATA,
    GET_BLANK_DOCUMENTS_SEARCH, GET_ENGINEERING_MASTER, GET_ALL_CURRENCY_TYPES, GET_ALL_FILTERS, CHANGE_PASSWORD, GET_NOTIFICATIONS, CHANGE_PASSWORD_ERROR,
    PENDING_ACTIVITIES,
    PENDING_ACTIVITIES_ERROR,
    GET_SIGNUP
} from '../type'

const initialState = {
    inspectionStatus: [],
    masterdata: [],
    loading: true,
    blankdocument: [],
    engineeringMaster: [],
    currencyMaster: [],
    filterList: [],
    passStatus: '',
    notifications: [],
    getsignup: [],
    pendingActivities: [],
    error: [],
}

export default function masterReducer(state = initialState, action) {
    switch (action.type) {

        case GET_INSPECTION_STATUS_MASTER:
            return {
                ...state,
                inspectionStatus: action.payload,
                loading: false
            }

        case GET_ALL_MASTER_DATA:
            return {
                ...state,
                masterdata: action.payload,
                loading: false
            }

        case GET_BLANK_DOCUMENTS_SEARCH:
            return {
                ...state,
                blankdocument: action.payload,
                loading: false
            }

        case GET_ENGINEERING_MASTER:
            return {
                ...state,
                engineeringMaster: action.payload,
                loading: false
            }

        case GET_ALL_CURRENCY_TYPES:
            return {
                ...state,
                currencyMaster: action.payload,
                loading: false
            }
        case GET_ALL_FILTERS:
            return {
                ...state,
                filterList: action.payload,
                loading: false
            }
        case CHANGE_PASSWORD:
            return {
                ...state,
                passStatus: action.payload,
                loading: false
            }
        case CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                passStatus: action.payload,
                loading: false
            }
        case GET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.payload,
                loading: false
            }
        case GET_SIGNUP:
            return {
                ...state,
                getsignup: action.payload,
                loading: false
            }
        case PENDING_ACTIVITIES:
            return {
                ...state,
                pendingActivities: action.payload,
                loading: false
            }
        case PENDING_ACTIVITIES_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            }

        default: return state
    }

}